import type { RouteRecordRaw } from 'vue-router';

// Self-service security settings. Authed (no authFree flag).
const securityRoutes: RouteRecordRaw[] = [
  {
    path: '/security',
    name: 'security',
    component: () => import('@/domains/security/views/SecurityView.vue'),
    meta: { renderer: 'native' },
  },
];

export default securityRoutes;
